import { Route } from "react-router-dom";
import ProtectedRoute from "src/routes/middlewares/ProtectedRoute";
import DashboardSubscriptionThanksView from "src/views/authenticated/subscription/SubscriptionThanksView";
import DashboardSubscriptionView from "src/views/authenticated/subscription/SubscriptionView";

const SubscriptionRoutes = [
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardSubscriptionView />
			</ProtectedRoute>
		}
		path="/subscription"
		key="/subscription"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardSubscriptionThanksView />
			</ProtectedRoute>
		}
		path="/subscription/:slug/thanks"
		key="/subscription/:slug/thanks"
	/>,
];
export default SubscriptionRoutes;
